import React from 'react';
import { Box } from '@mui/material';

const Logo = ({ 
  size = 'medium', 
  sx = {}, 
  alt = 'Walkmore.uk Logo',
  ...props 
}) => {
  // Size presets
  const sizeConfig = {
    small: { maxWidth: '120px', maxHeight: '48px' },
    medium: { maxWidth: '200px', maxHeight: '80px' },
    large: { maxWidth: '300px', maxHeight: '120px' }
  };

  const currentSize = typeof size === 'object' ? size : sizeConfig[size] || sizeConfig.medium;

  return (
    <Box sx={{ textAlign: 'center', ...sx }} {...props}>
      <img 
        src="/images/main_logo.jpg" 
        alt={alt}
        style={{
          ...currentSize,
          width: 'auto',
          height: 'auto',
          objectFit: 'contain'
        }}
        onError={(e) => {
          // Hide image if it fails to load
          e.target.style.display = 'none';
        }}
      />
    </Box>
  );
};

export default Logo;